import lines from "./win-lines";
export const winLines = lines["5x3"];

const config = {
  documentFontSize: 24, // the font size of the document without any scale applied, used to calculate the icons size
  assetsLocation: {
    production: "/ui/",
    development: "./",
    test: "./",
  },
  paytable: {
    background: "paytable/background.webp",
    header: "paytable/header.webp",
  },
  loadingScreen: {
    main: { image: "loading-screen/main.webp", color: "black" },
    logo: { image: "loading-screen/logo.webp", maxWidth: "900px" },
    effect: { image: "loading-screen/effect.webp" },
    background: { image: "loading-screen/background.webp" },
    progress: {
      full: {
        backgroundColor: "#c8c8c8",
        boxShadow: "0px 0px 10px 1px #fafafa",
      },
      empty: {
        backgroundColor: "#111111",
        outlineColor: "#202020",
      },
    },
  },
  layouts: {
    portrait: 0.9,
    landscape: Infinity,
  },
  turboSpin: false,
};

export default config;
